// CTASection.js
import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import ConsultationModal from '../ConsultationModal';

const CTASection = () => {
  const [showConsultationModal, setShowConsultationModal] = useState(false);

  return (
    <section className="py-20 bg-[#202356]">
      <div className="max-w-4xl mx-auto px-4 md:px-8 text-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <h2 className="text-3xl md:text-4xl font-semibold text-white mb-6">
            Start Your Work Abroad Journey with Clarity
          </h2>
          <p className="text-gray-300 text-base font-light leading-relaxed mb-8 max-w-2xl mx-auto">
            Book an eligibility consultation to understand your options, assess your readiness, and receive clear guidance on next steps.
          </p>
          <button
            onClick={() => setShowConsultationModal(true)}
            className="inline-flex items-center gap-2 bg-white hover:bg-gray-100 text-[#202356] font-normal text-base px-8 py-4 rounded-lg transition-colors"
          >
            Book an Eligibility Consultation
            <ArrowRight size={20} />
          </button>
        </motion.div>
      </div>

      {/* Consultation Modal */}
      <ConsultationModal 
        isOpen={showConsultationModal}
        onClose={() => setShowConsultationModal(false)}
        serviceType="work-abroad"
      />
    </section>
  );
};

export default CTASection;
